import React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, Button, Grow, MenuItem, Paper } from '@mui/material';
import {
  countries,
  internationCountries,
} from '../../landingpage/components/Countries';

export default function BirthCountry({
  updateFinalResults,
  finalResults,
  questionIndex,
  handleAnswerClick,
  questionDisplayed,
  setError,
  error,
}) {
  const handleChange = (country, index) => {
    if (country === null) {
      updateFinalResults({
        birth_country: '',
      });
      setError(true);
      return;
    }
    setError(false);

    updateFinalResults({
      birth_country: country,
    });

    const scrollBy = window.scrollY + 300;
    window.scrollTo({ top: scrollBy, behavior: 'smooth' });

    handleAnswerClick(index);
  };

  return (
    <Grow
      className={questionDisplayed ? 'height100' : 'height0 opacity0'}
      in={questionDisplayed}
    >
      <div>
        <h3 className="mt30 mb0">What country were you born in?</h3>
        <div className="mt10 alignitemscenter dflex">
          <Button
            size="large"
            style={{ width: 100 }}
            className={
              'answer-btn ' +
              (finalResults.birth_country === 'Australia'
                ? 'selected-answer'
                : '')
            }
            onClick={() => {
              handleAnswerClick(questionIndex);
              const scrollBy = window.scrollY + 300;
              window.scrollTo({ top: scrollBy, behavior: 'smooth' });
              updateFinalResults({
                birth_country: 'Australia',
              });
            }}
          >
            Australia
          </Button>
          OR
          <Autocomplete
            value={
              finalResults.birth_country === 'Australia'
                ? ''
                : finalResults.birth_country || null
            }
            style={{ width: 200 }}
            PaperComponent={({ children }) => (
              <Paper
                sx={{
                  '& .MuiAutocomplete-listbox': { overflowX: 'hidden' },
                  '.MuiInputBase-input': { fontSize: 14 },
                  '& .MuiAutocomplete-listbox > li::before': {
                    color: 'transparent',
                  },
                }}
                className="autocomplete"
              >
                {children}
              </Paper>
            )}
            error={error}
            fullWidth
            defaultValue=""
            onChange={(e, newValue) => handleChange(newValue, questionIndex)}
            options={countries}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  '.MuiInputBase-input': { fontSize: 14 },
                }}
                InputLabelProps={{
                  style: { fontSize: 14 },
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                label="Select Country"
              />
            )}
          />
        </div>
      </div>
    </Grow>
  );
}
